import PropTypes from 'prop-types';
import React from 'react';
import Relay from 'react-relay';
import ResourceImage from './ResourceImage';

class InlineSearchResult extends React.Component {

    render() {

        const resource = this.props.resource;

        return (
            <div key={resource.id} className="thumbnail-grid__item">
                <a href="#" onClick={ e => this._handleClick(resource, e) } title={resource.title}>
                    <ResourceImage className="thumbnail-grid__item-inner" resource={resource} />
                </a>
            </div>
        );
    }

    _handleClick = (resource, e) => {
        e.preventDefault();

        if(this.props.handleClick) {
            this.props.handleClick(resource, e);
        }
    }
}

InlineSearchResult.propTypes = {
    handleClick: PropTypes.func,
};

export default Relay.createContainer(InlineSearchResult, {

    fragments: {
        resource: () => Relay.QL`
          fragment on Resource {
            id
            type
            title
            ${ResourceImage.getFragment('resource')}
        }
        `
  }
});



// WEBPACK FOOTER //
// ./webapp/components/modules/InlineSearchResult.js